import React from 'react';
import { GridSize } from '@material-ui/core';
import RadioButtonsGroup from '../RadioButtonGroup';
import { DisplayItem } from '../../../types';
import InputProps from '../InputProps';
import { generateProperties } from '../helpers';

interface BooleanRadioGroupProps extends InputProps<boolean> {
  gutterLeft?: boolean;
  boldLabel?: boolean;
  disabledValues?: string[];
  acceptText?: string;
  rejectText?: string;
  centerLabels?: boolean;
  gridSize?: GridSize;
}

const BooleanRadioGroup = ({
  inputId,
  inputName,
  inputLabel,
  onChange,
  defaultValue,
  inputErrorMessage = '',
  dataSource,
  gutterLeft = false,
  boldLabel = false,
  isDisabled = false,
  disabledValues = [],
  acceptText = 'Sí',
  rejectText = 'No',
  gridSize = 6,
  centerLabels,
}: BooleanRadioGroupProps): JSX.Element => {
  const booleanRadioValues: DisplayItem[] = [
    { Value: 'true', Text: acceptText },
    { Value: 'false', Text: rejectText },
  ];

  const formInputProps = generateProperties<boolean>({
    inputName,
    onChange,
    defaultValue,
    inputErrorMessage,
    dataSource,
  });

  function valueText(): string {
    if (typeof formInputProps.value === 'undefined') {
      return '';
    }
    return formInputProps.value ? 'true' : 'false';
  }

  function handleChange(newVal: DisplayItem): void {
    formInputProps.onChange(newVal.Value === 'true');
  }

  return (
    <RadioButtonsGroup
      inputId={inputId}
      formTitle={inputLabel}
      radioData={booleanRadioValues}
      radioGroupName={inputName}
      gridSize={gridSize}
      defaultValue={valueText()}
      onChange={handleChange}
      errorMessage={formInputProps.errorText}
      gutterLeft={gutterLeft}
      disabled={isDisabled}
      disabledValues={disabledValues}
      boldLabel={boldLabel}
      centerLabels={centerLabels}
    />
  );
};

export default BooleanRadioGroup;
